// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2qKnY","label":"Category_label__3Ei9v","content":"Category_content__29tZ6","header":"Category_header__2GNH6","location":"Category_location__Ov8Zv"};